<header class="flex-none w-full px-6 overflow-hidden [scrollbar-gutter:stable]">
  <div class="max-w-[1120px] mx-auto pt-2 pb-2 has-[kendo-tabstrip]:pb-0 border-b border-solid border-neutral-20">
    <div class="flex flex-col gap-1">
      <h5 class="m-0 flex items-center gap-2.5">{{ 'aiHub.shell.title' | translate }}</h5>
      <p class="m-0 text-body-2 text-neutral-60">
        @if (store.status() === 'ready') {
          {{ (store.isAdmin() ? 'aiHub.intro.admin' : 'aiHub.intro.user') | translate }}
        }
      </p>
    </div>
    @if (store.status() === 'ready') {
      @if (store.banner(); as banner) {
        <maximizer-notification-banner
          class="block mt-2"
          [bannerModel]="{ message: (banner.messageKey | translate), iconClass: banner.iconClass, backgroundClass: banner.backgroundClass }"
        />
      }
      <kendo-tabstrip class="mt-3" [showContentArea]="false" (tabSelect)="onTabSelect($event)">
        @for (tab of tabs(); track tab.id) {
          <kendo-tabstrip-tab [title]="tab.titleKey | translate" [selected]="store.activeTab() === tab.id" />
        }
      </kendo-tabstrip>
    }
  </div>
</header>

<section class="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] px-6">
  <div class="max-w-[1120px] mx-auto pt-4 pb-16">
    @if (store.status() === 'ready') {
      @switch (store.activeTab()) {
        @case ('general') {
          <ai-hub-general-tab />
        }
        @case ('tools') {
          <ai-hub-tools-tab (openApp)="openFeatureApp($event)" />
        }
        @case ('preferences') {
          <ai-hub-preferences-tab />
        }
      }
    } @else if (store.status() === 'error') {
      <div class="flex flex-col items-center gap-3 py-12">
        <p class="text-body-2 text-neutral-90 m-0">{{ 'aiHub.shell.loadError' | translate }}</p>
        <button data-testid="ai-hub-retry" kendoButton themeColor="primary" type="button" (click)="store.initialize()">
          {{ 'aiHub.shell.retry' | translate }}
        </button>
      </div>
    } @else {
      <div class="absolute inset-0 z-50 flex items-center justify-center">
        <img [src]="loadingGifUrl()" alt="" />
        <div class="absolute inset-0 bg-white opacity-30"></div>
      </div>
    }

    <maximizer-notification #saveError type="error" icon="circle-exclamation" [hideAfter]="4000">
      {{ 'aiHub.shell.saveError' | translate }}
    </maximizer-notification>
  </div>
</section>
